import $ from 'jquery';
import cookie from 'react-cookies';
import * as globalUtils from '../../Global/global_js';
var video_guid = "";
var pre_roll_vod_guid = "";
var pre_roll_skip_time = 5;
var pre_roll_start_time = "00:00:00";
var pre_roll_adsource = "";
var pre_roll_vod_enabled = "False";
var pre_roll_vod_url = "";
var adsource_obj_arr = [];
//var error_info = localStorage.getItem("error_info");
export function get_browser_name()
{
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    // Firefox 1.0+
    if (typeof InstallTrigger !== 'undefined')
    {
        return "Firefox";
    }
    // Safari 3.0+ "[object HTMLElementConstructor]" 
    else if ((/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification))) === true)
    {
        return "Safari";
    }
    // Internet Explorer 6-11
    else if ((/*@cc_on!@*/false || !!document.documentMode) === true)
    {
        return "Internet Explorer";
    }
    // Edge 20+
    else if ((!isIE && !!window.StyleMedia) === true)
    {
        return "Edge";
    }
    // Chrome 1 - 79
    else if ((!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) === true)
    {
        return "Chrome";
    }
    else if ((isChrome && (navigator.userAgent.indexOf("Edg") != -1)) === true)
    {
        return "Edge";
    }

    else { return ""; }
}
export function get_pre_roll_info(t)
{
    try
    {
        video_guid = t.state.videoData.videoGuid;
        if (video_guid !== "")
        {
            var api_link = localStorage.getItem("api_url") + "get_pre_roll_info";
            var parameters = {
                media_guid: video_guid,
                error_info: "account_guid=" + t.state.videoData.user_guid + "&media_guid=" + video_guid
            };

            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                { get_pre_roll_info_success(t, response); },
                error: function (response)
                { get_pre_roll_info_error(t, response); },
            });
        }
        else
        {
            window.location = "home";
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "get_pre_roll_info",
            ex, "account_guid=" + t.state.videoData.user_guid + "&video_guid=" + video_guid);
    }
}
function get_pre_roll_info_success(t, response)
{
    try
    {
        if (response)
        {

            for (var i = 0; i < response.length; i++)
            {
                pre_roll_vod_guid = response[i].vod_guid;
                pre_roll_skip_time = response[i].pre_roll_skip_time;
                pre_roll_start_time = response[i].pre_roll_start_time;
                pre_roll_adsource = response[i].pre_roll_ad_link;
                pre_roll_vod_enabled = response[i].pre_roll_vod_enabled;

                if (pre_roll_vod_enabled == "True")
                {
                    console.log("t.state.videoData.creator_id = ", t.state.videoData.creator_id);
                    adsource_obj_arr.push({
                        url: localStorage.getItem("get_player_link") + "player_handler.ashx?vt=1&ag=" + response[i].owner_account_guid + "&fn=" + pre_roll_vod_guid + ".mp4" + "&ci=" + t.state.videoData.creator_id,
                        //url: "https://api.helnix.com/streamsie_api/player_handler.ashx?vt=1&ag=0766a1ee&fn=8d9a42e349.mp4&ci=0",
                        type: 'video',
                        starttime: pre_roll_start_time,
                        skiptime: pre_roll_skip_time,
                        adlink: pre_roll_adsource
                    });
                }
            }
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    Adsources: adsource_obj_arr,
                },
            }))

        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "get_pre_roll_info_success",
            ex, "account_guid=" + t.state.videoData.user_guid + "&video_guid=" + video_guid);
    }
}
function get_pre_roll_info_error(t,ex)
{
    globalUtils.send_error_fun("playerUiJs_index.js",
        "get_pre_roll_info_error",
        ex, "account_guid=" + t.state.videoData.user_guid + "&video_guid=" + video_guid);
}

export function pay_donation_with_creditcard(t)
{
    t.setState({ DonationModalblocking: true });
    var api_link = "/api/HData/pay_Donation_with_creditcard/data";
    var card_info = {
        card_number: t.state.card_info.card_number,
        card_expiration_year: t.state.card_info.card_expiration_year,
        card_expiration_month: t.state.card_info.card_expiration_month,
        card_verfication_no: t.state.card_info.card_verfication_no,
        card_type: t.state.card_info.card_type,
        card_first_name: t.state.card_info.card_first_name,
        card_last_name: t.state.card_info.card_last_name,
        card_address: t.state.card_info.card_address,
        card_country: "US",
        card_city: t.state.card_info.card_city,
        card_state: t.state.card_info.card_state,
        card_ZIP_code: t.state.card_info.card_ZIP_code,
        vod_guid: t.state.videoData.videoGuid,
        vod_type: t.state.videoData.videoType,
        channel_guid: t.state.videoData.channelGuid,
        money: t.state.donationMoney,
        user_ip: t.state.videoData.visitor_ip,
        video_title: t.state.videoData.video_title,
        owner_account_id: parseInt(t.state.videoData.video_owner_account_id),
        vod_donation_paypal_id: parseInt(t.state.videoData.vod_donation_paypal_id),
        user_message: t.state.donationMessage
    };

    $.ajax({
        type: "POST",
        url: api_link,
        data: JSON.stringify(card_info),
        async: true,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        { pay_donation_with_creditcard_success(t, response); },
        error: function (response)
        { pay_donation_with_creditcard_error(t, response); }
    });
}
function pay_donation_with_creditcard_success(t, response)
{
    t.setState({ DonationModalblocking: false });
    if (response.indexOf("true")>-1)
    {
        t.setState(prevs => ({
            videoData: {
                ...prevs.videoData,
                video_donation_transaction: response.split("_")[1]
            }
        }))
        //t.showToast("Thanks for your donation", "success");
    }
    else
    {
        t.showToast("Error occured please contact admin", "error");
    }
}
function pay_donation_with_creditcard_error(t, ex)
{
    t.setState({ DonationModalblocking: false });
    t.showToast("Error occured please contact admin", "error");
}

export function payDonationWithPaypal(t)
{
    get_paypal_url(t);
}

function get_paypal_url(t)
{
    var api_link = "/api/HData/get_donation_paypal_url/data";

    $.ajax({
        type: "POST",
        url: api_link,
        async: false,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        { get_paypal_url_success(t, response); },
        error: get_paypal_url_error
    });
}
function get_paypal_url_success(t, response)
{
    if (response !== "")
    {
        window.location.href = response + "vg=" + t.state.videoData.videoGuid
            + "&vt=" + t.state.videoData.videoType + "&ppid=" + t.state.videoData.vod_donation_paypal_id
            + "&pr=" + t.state.donationMoney + "&ch=" + t.state.videoData.channelGuid + "&vtt=" + t.state.videoData.video_title
    }
}
function get_paypal_url_error(ex)
{

}

export function payDownloadVideoWithPaypal(t)
{
    get_paypal_url_for_download_video(t);
}

function get_paypal_url_for_download_video(t)
{
    var api_link = "/api/HData/get_download_video_paypal_url/data";

    $.ajax({
        type: "POST",
        url: api_link,
        async: false,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        { get_paypal_url_for_download_video_success(t, response); },
        error: get_paypal_url_for_download_video_error
    });
}
function get_paypal_url_for_download_video_success(t, response)
{
    
    if (response !== "")
    {
        window.location.href = response + "vg=" + t.state.videoData.videoGuid
            + "&vt=" + t.state.videoData.videoType + "&ppid=" + t.state.videoData.payment_id_for_download_videos
            + "&pr=" + t.state.downloadVideoPrice + "&ch=" + t.state.videoData.channelGuid + "&vtt=" + t.state.videoData.video_title
            + "&em=" + t.state.buy_download_video_email
    }
}
function get_paypal_url_for_download_video_error(ex)
{

}

export function updatePaypalButtonCode(t)
{
    try
    {

        var api_link = localStorage.getItem("api_url") + "react_update_paypal_button_code_by_video_guid";
        var parameters =
        {
            vod_guid: t.state.videoData.videoGuid,
            vod_type: t.state.videoData.videoType,
            paypal_button_code: t.state.videoData.paypalButtonCode,
            paypal_button_title: t.state.videoData.paypalButtonCodeTitle,
            error_info: "account_guid=" + t.state.videoData.user_guid + "&video_guid=" + t.state.videoData.videoGuid
        };

        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: true,
            dataType: "json",
            success: function (response)
            { updatePaypalButtonCode_success(t, response) },
            error: function (response)
            { updatePaypalButtonCode_error(t, response); }
        });
    }
    catch (ex)
    {

    }
}
function updatePaypalButtonCode_success(t, response)
{
    if (response === true)
    {
        t.onCloseAddPaypalButtonPopup();
        if (t.state.videoData.paypalButtonCode)
        {
            document.getElementById("paypal_button_div").innerHTML = t.state.videoData.paypalButtonCode;
        }
        else if (document.getElementById("paypal_button_div"))
        {
            document.getElementById("paypal_button_div").innerHTML = "";
        }
    }
    else
    {
        t.showToast("Error occured, please contact admin", "error");
    }
}
function updatePaypalButtonCode_error(t, ex)
{
    t.showToast("Error occured, please contact admin", "error");
}